/* global axios */
import ApiClient from './ApiClient';

class GoogleAdsAPI extends ApiClient {
  constructor() {
    super('google_ads', { accountScoped: true });
  }

  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  saveConfig(payload) {
    return axios.post(`${this.url}/config`, payload);
  }

  removeConfig() {
    return axios.delete(`${this.url}/config`);
  }

  authorizeUrl() {
    return axios.get(`${this.url}/authorize_url`);
  }

  getAccounts() {
    return axios.get(`${this.url}/accounts`);
  }

  getConversionActions(customerId) {
    return axios.get(`${this.url}/conversion_actions`, {
      params: { customer_id: customerId },
    });
  }

  createConversionAction(customerId) {
    return axios.post(`${this.url}/create_conversion_action`, {
      customer_id: customerId,
    });
  }

  getCampaigns(customerId, days) {
    return axios.get(`${this.url}/campaigns`, {
      params: { customer_id: customerId, days },
    });
  }

  getCrmConversions(days) {
    return axios.get(`${this.url}/crm_conversions`, { params: { days } });
  }

  updateCampaign(customerId, campaignId, status) {
    return axios.post(`${this.url}/update_campaign`, {
      customer_id: customerId,
      campaign_id: campaignId,
      status,
    });
  }

  getKeywords(customerId, campaignId) {
    return axios.get(`${this.url}/keywords`, {
      params: { customer_id: customerId, campaign_id: campaignId },
    });
  }

  addKeywords(customerId, campaignId, keywords, matchType) {
    return axios.post(`${this.url}/add_keywords`, {
      customer_id: customerId,
      campaign_id: campaignId,
      keywords,
      match_type: matchType,
    });
  }

  updateKeyword(customerId, adGroupId, criterionId, status) {
    return axios.post(`${this.url}/update_keyword`, {
      customer_id: customerId,
      ad_group_id: adGroupId,
      criterion_id: criterionId,
      status,
    });
  }

  callback(code, accountId) {
    // O popup do OAuth abre em /google-ads/callback (sem /accounts/:id na URL),
    // então this.url não é account-scoped aqui. Montamos a rota com o accountId
    // vindo do state do OAuth pra bater na rota scoped correta.
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/${this.resource}/callback`,
      { code }
    );
  }
}

export default new GoogleAdsAPI();
